import { nothing as l } from "lit";
import { classMap as b } from "lit/directives/class-map.js";
import { unsafeStatic as t, literal as $, html as a } from "lit/static-html.js";
import { getCustomElementSuffix as u } from "../../api/custom-element-scope.js";
import g from "../../assets/img/logo_axia.svg.js";
const c = $`dss-icon${t(u())}`, f = $`dss-tooltip${t(u())}`, v = $`dss-notification-badge${t(u())}`, o = $`dss-sidemenu-list${t(u())}`, n = $`dss-sidemenu-list-item${t(u())}`, M = $`dss-action-menu${t(u())}`, x = $`dss-action-menu-item${t(u())}`, h = (e, s, d) => a`
    <${M} class="dss-sidemenu-nested-menu">
      ${e.map(
  (i) => a`
        <${x}
          class=${b({
    hidden: !!s
  })}
          lefticon=${i.icon}
          label=${i.label}
          notifications=${i.notifications}
          ?disabled=${i.disabled}
          ?hasNestedMenu=${!!i.nestedMenu}
           @click=${(r) => d._handleMenuClick(r, i)}
        >
          ${i.nestedMenu ? h(i.nestedMenu, !1, d) : l}
        </${x}>
      `
)}
    </${M}>
  `, k = (e) => {
  if (!e._othersTopItem) return 0;
  const s = e._othersTopItem.querySelectorAll("dss-action-menu-item"), d = Array.from(s).filter(
    (r) => {
      var _;
      return ((_ = r.parentElement) == null ? void 0 : _.parentElement) === e._othersTopItem && r.classList.contains("hidden") === !1;
    }
  );
  let i = 0;
  for (const r of d) {
    const _ = r.getAttribute("notifications");
    _ && (i += Number(_));
  }
  return i;
}, y = (e) => a`
  <aside
    class=${b({
  "dss-sidemenu": !0,
  "dss-sidemenu--expanded": !!e._expanded
})}
  >
    
    ${e.topMenuItems.length > 0 ? a`
        <div class="dss-sidemenu-extra-menu">
        <${o} ?expanded=${e._expanded}>
          ${e.topMenuItems.map(
  (s) => a`
            <${n}
              icon=${s.icon}
              label=${s.label}
              notifications=${s.notifications}
              ?selected=${s.selected && !e._hasManualSelected}
              ?disabled=${s.disabled}
              ?hasNestedMenu=${!!s.nestedMenu}
              ?expanded=${e._expanded}
              @click=${(d) => e._handleMenuClick(d, s)}
              @keydownEscape=${e._handleKeydownEscape}
              >
              ${s.nestedMenu ? h(s.nestedMenu, !1, e) : l}
            </${n}>
          `
)}
        </${o}>
      </div>
      <div class="dss-sidemenu-divider"></div>
      ` : l}

    ${e.roleMenuItems.length > 0 ? a`
        <div class="dss-sidemenu-top-menu">
          <${o} ?expanded=${e._expanded}>
            ${e.roleMenuItems.map(
  (s) => a`
              <${n}
                icon=${s.icon}
                label=${s.label}
                notifications=${s.notifications}
                ?selected=${s.selected && !e._hasManualSelected}
                ?disabled=${s.disabled}
                ?hasNestedMenu=${!!s.nestedMenu}
                ?expanded=${e._expanded}
                @click=${(d) => e._handleMenuClick(d, s)}
                @keydownEscape=${e._handleKeydownEscape}
                >
                ${s.nestedMenu ? h(s.nestedMenu, !1, e) : l}
              </${n}>
            `
)}
            <${n} 
              class="dss-sidemenu-top-menu__other-items hidden"
              expanded=${e._expanded}
              icon="more_horiz"
              label="Altres"
              notifications=${k(e)}
              @keydownEscape=${e._handleKeydownEscape}
              hasNestedMenu>
               ${h(e.roleMenuItems, !0, e)}
            </${n}>
          </${o}>
        </div>
    ` : l}

    ${e._hideCreateMenu ? l : a`
          <div
            class="dss-sidemenu-create"
            @focusout="${e._handleCreateFocusout}"
          >
            <button
              class="dss-sidemenu-create__button"
              ?disabled=${e._createDisabled}
              @click="${e._openCreateMenu}"
              @mouseenter="${e._handleCreateMouseEnter}"
              @mouseleave="${e._handleCreateMouseLeave}"
              @mousedown="${e._handleCreateMouseDown}"
              @mouseup="${e._handleCreateMouseUp}"
              aria-label="${e._createLabel}"
            >
              <span class="dss-sidemenu-create__button__content">
                <${c} class="dss-sidemenu-create__icon" size="md" icon="add"></${c}>
                ${e._createNotifications && !e._showCreateDropdown && !e._createDisabled ? a`
                      <${v}
                        class=${b({
  "dss-sidemenu-create__notification": !0,
  "dss-sidemenu-create__notification--expanded": !0
})}
                        value="${e._createNotifications}"
                        state="error"
                        type="default"
                        borderWhite
                      />
                    ` : null}
              </span>
              <span class= class=${b({
  "dss-sidemenu-label-animation": !0,
  "dss-sidemenu-label-animation--expanded": e._expanded
})}>
                  ${e._createLabel}
              </span>
            </button>

            <${f} position="right" class="dss-sidemenu-create__tooltip">
              ${e._createLabel}
            </${f}>

            <${M}>
              ${e.createMenuItems.map(
  (s) => a`
                <${x}
                  label=${s.label}
                  notifications=${s.notifications}
                  @click=${(d) => e._handleMenuClick(d, s)}
                  >
                </${x}>
              `
)}
            </${M}>
          </div>
        `}

    <div class="dss-sidemenu-bottom">
      <div class="dss-sidemenu-bottom-menu">
        <div class="dss-sidemenu-divider"></div>
          ${e.globalMenuItems.length > 0 ? a`
            <${o} ?expanded=${e._expanded}>
              ${e.globalMenuItems.map(
  (s) => a`
                <${n}
                  icon=${s.icon}
                  label=${s.label}
                  notifications=${s.notifications}
                  ?selected=${s.selected && !e._hasManualSelected}
                  ?disabled=${s.disabled}
                  ?hasNestedMenu=${!!s.nestedMenu}
                  ?expanded=${e._expanded}
                  @click=${(d) => e._handleMenuClick(d, s)}
                  @keydownEscape=${e._handleKeydownEscape}
                  >
                  ${s.nestedMenu ? h(s.nestedMenu, !1, e) : l}
                </${n}>
              `
)}
            </${o}>
           ` : l}
          ${e.axiaHidden ? l : a`
            <div class="dss-sidemenu-toggle-axia">
              <button
                class="dss-sidemenu-axia"
                ?disabled=${e.axiaDisabled}
                @click="${e._handleAxia}"
              >
                <span class="dss-sidemenu-axia__content">
                  <img src="${g}" alt="Logo Axia" class="dss-sidemenu-axia__logo" />
                  <span class="dss-sidemenu-axia__label">${e.axiaLabel}</span>
                </span>
              </button>
              <${f} position="right" class="dss-sidemenu-axia__tooltip">
                ${e.axiaLabel}
              </${f}>
            </div>
          `}
        </div>
     
      
      <button
        class="dss-sidemenu-toggle"
        ?disabled=${e._toggleDisabled}
        @click="${e._toggleSidemenu}"
        aria-label="${e._expanded ? "col·lapsar menú" : "expandir menú"}"
      >
        ${e._expanded ? a`
              <${c} class="dss-sidemenu-toggle__icon" size="md" icon="chevron_left"></${c}>
            ` : a`
              <${c} class="dss-sidemenu-toggle__icon" size="md" icon="chevron_right"></${c}>
            `}
        <span class= class=${b({
  "dss-sidemenu-label-animation": !0,
  "dss-sidemenu-label-animation--expanded": e._expanded
})}>
            ${e._toggleLabel}
        </span>
      </button>
    </div>
  </aside>
`;
export {
  y as sidemenuTemplate
};
//# sourceMappingURL=side-menu.template.js.map
